<template>
  <div
    v-touch:swipe.right="removeHandler"
    v-touch:swipe.left="removeHandler"
    v-touch:longtap="editHandler"
    @click="$emit('click')"
    class="item"
  >
    <div class="item__actions">
      <button @click="$emit('edit')" title="Edit"></button>
      <button @click="$emit('remove')" title="Delete"></button>
    </div>
    <p class="item__title">{{ name }}</p>
    <small class="item__date">{{ date }}</small>
    <a @click.prevent="$emit('open')" class="stretched-link" title="Open"></a>
  </div>
</template>

<script>
import Vue from "vue";
import Vue2TouchEvents from "vue2-touch-events";

Vue.use(Vue2TouchEvents);

export default {
  name: "Item",
  props: {
    name: String,
    date: String,
    edit: Boolean
  },
  methods: {
    removeHandler() {
      this.$emit("remove");
    },
    editHandler() {
      this.$emit("edit");
    }
  }
};
</script>

<style scoped>
.item {
  cursor: pointer;
  min-width: 18rem;
  min-height: 8rem;
  word-break: break-all;
  border-radius: var(--brs);
  padding: var(--gutter);
  transition: var(--smooth-slow);
  position: relative;
  background: rgb(var(--gray-4));
  overflow: hidden;
  margin-right: var(--gutter);
  margin-bottom: var(--gutter);
}

.item::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  transition: var(--smooth-fast);
  pointer-events: none;
}

.item:hover::after {
  background: rgba(var(--accent), 0.2);
}

.item__actions {
  display: flex;
  position: absolute;
  right: 0;
  top: 0;
  padding: 0.5rem;
}

.item__actions button {
  z-index: 1;
  width: 1rem;
  height: 1rem;
  border-radius: 1rem;
  border: none;
  background: rgb(var(--gray-3));
  transition: var(--smooth-fast);
}

.item__actions button:not(:last-child) {
  margin-right: calc(var(--gutter) / 2);
}

.item__actions button:hover {
  opacity: 0.6;
}

.item__actions button[title="Edit"] {
  background: rgb(255, 193, 7);
}

.item__actions button[title="Delete"] {
  background: rgb(220, 53, 69);
}

.stretched-link {
  width: 100%;
  height: 100%;
}

.stretched-link::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

@media (max-width: 768px) {
  .item__actions {
    padding: 1rem;
  }

  .item__actions button {
    width: 1.2rem;
    height: 1.2rem;
    border-radius: 1.2rem;
  }
}
</style>
